export default __webpack_public_path__ + "static/media/Implant.f4347a1f.jpg";